var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.087 15.6852H16.9439L16.5388 15.3002C17.9568 13.6746 18.8105 11.5643 18.8105 9.26852C18.8105 4.14944 14.5998 0 9.40524 0C4.21066 0 0 4.14944 0 9.26852C0 14.3876 4.21066 18.537 9.40524 18.537C11.7348 18.537 13.8764 17.6957 15.5259 16.2983L15.9166 16.6976V17.8241L19.844 22L22 19.8754L18.087 15.6852ZM9.40524 15.6852C5.80231 15.6852 2.89392 12.8191 2.89392 9.26852C2.89392 5.71796 5.80231 2.85185 9.40524 2.85185C13.0082 2.85185 15.9166 5.71796 15.9166 9.26852C15.9166 12.8191 13.0082 15.6852 9.40524 15.6852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.1442318e447eac4df58998594f9581dd.svg";
export { ForwardRef as ReactComponent };